/* Nomadia · tiroir panier maison.
   Les lignes sont regroupées par variante : une application (MoonBundle) peut découper
   une même variante en plusieurs lignes selon ses paliers, la cliente ne doit pas le voir.
   Fluidité : panier en mémoire, affichage immédiat, file d'attente, réponses périmées ignorées. */
(function () {
  if (window.__nmcPret) return;
  window.__nmcPret = true;

  var CONF = window.NMC || {};
  var GIFTS = CONF.cadeaux || ['nomad-wash-trousse-de-toilette', 'sac-a-chaussures'];
  var DEVISE = CONF.devise || 'EUR';
  var RETOUR = CONF.retour || '/';
  var JOURS = CONF.joursLivraison || 5;
  var ANIM = 340;
  var DELAI = 260;

  var racine, panneau, lignes, compteur, cta, recap, dateEl;
  var barresCache = {};
  var panier = null;
  var groupes = [];
  var panierA = 0;
  var empreinte = '';
  var anime = false;
  var enAttente = null;
  var fermeture = null;
  var cibles = {};
  var envoiEnCours = false;
  var minuteur = null;
  var version = 0;

  function euro(c) {
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: DEVISE }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function estCadeau(h) { return GIFTS.indexOf(h) !== -1; }
  function miniature(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=160';
  }
  function dateArrivee() {
    var J = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
    var M = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
    var d = new Date();
    d.setDate(d.getDate() + JOURS);
    if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    return J[d.getDay()] + ' ' + d.getDate() + ' ' + M[d.getMonth()];
  }
  function enFile() { for (var k in cibles) { if (cibles.hasOwnProperty(k)) return true; } return false; }

  function barres(handle) {
    if (barresCache[handle]) return Promise.resolve(barresCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var m = {};
        p.variants.forEach(function (v) { m[v.id] = v.compare_at_price || 0; });
        barresCache[handle] = m;
        return m;
      })
      .catch(function () { barresCache[handle] = {}; return {}; });
  }

  /* Une entrée par variante, même si le panier contient plusieurs lignes */
  function regroupe(cart) {
    var parVariante = {};
    var ordre = [];
    cart.items.forEach(function (i) {
      var id = String(i.variant_id);
      if (!parVariante[id]) {
        parVariante[id] = {
          id: id,
          handle: i.handle,
          titre: i.product_title,
          image: i.image,
          options: (i.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; })
            .map(function (o) { return o.value; }).join(' · '),
          cadeau: estCadeau(i.handle),
          qte: 0, total: 0, base: 0, cles: []
        };
        ordre.push(parVariante[id]);
      }
      var g = parVariante[id];
      g.qte += i.quantity;
      g.total += i.final_line_price;
      var ref = (barresCache[i.handle] || {})[i.variant_id] || i.original_price || i.price;
      g.base += ref * i.quantity;
      g.cles.push(i.key);
    });
    return ordre;
  }
  function signature(gs, cart) {
    return cart.total_price + '|' + gs.map(function (g) { return g.id + ':' + g.qte + ':' + g.total; }).join(',');
  }

  function ligneHTML(g) {
    var img = miniature(g.image);
    var prix = g.cadeau ? 0 : g.total;
    return '' +
      '<article class="nmc__it' + (g.cadeau ? ' nmc__it--cadeau' : '') + '" data-id="' + g.id + '">' +
        '<span class="nmc__ph">' + (img ? '<img src="' + img + '" alt="" width="60" height="60">' : '') + '</span>' +
        '<span class="nmc__tx">' +
          '<span class="nmc__nm">' + g.titre +
            '<em class="nmc__q" data-mult>' + (g.cadeau && g.qte > 1 ? '×' + g.qte : '') + '</em>' +
            (g.cadeau ? ' <span class="nmc__tag">OFFERT</span>' : '') +
          '</span>' +
          (g.options && !g.cadeau ? '<span class="nmc__vr">' + g.options + '</span>' : '') +
        '</span>' +
        '<span class="nmc__pz"><s data-barre>' + (g.base > prix ? euro(g.base) : '') + '</s><b data-prix>' + euro(prix) + '</b></span>' +
        (g.cadeau ? '' :
          '<span class="nmc__act">' +
            '<span class="nmc__qt">' +
              '<button type="button" data-moins aria-label="Retirer un exemplaire">−</button>' +
              '<b data-qte>' + g.qte + '</b>' +
              '<button type="button" data-plus aria-label="Ajouter un exemplaire">+</button>' +
            '</span>' +
            '<button type="button" class="nmc__sup" data-sup aria-label="Supprimer cet article">' +
              '<svg viewBox="0 0 24 24"><path d="M4 7h16M9 7V5h6v2M7 7l1 13h8l1-13"/></svg>' +
            '</button>' +
          '</span>') +
      '</article>';
  }

  function majPied(cart, gs) {
    var base = 0;
    gs.forEach(function (g) { base += g.base; });
    if (base < cart.total_price) base = cart.items_subtotal_price || cart.total_price;
    var eco = Math.max(0, base - cart.total_price);
    var html = '<div class="nmc__rec-l"><span>Sous-total</span><span>' + euro(base) + '</span></div>';
    if (eco > 0) html += '<div class="nmc__rec-l"><span>🎉 Vous économisez</span><b>− ' + euro(eco) + '</b></div>';
    html += '<div class="nmc__rec-l"><span>Livraison</span><b>Offerte</b></div>' +
      '<div class="nmc__rec-t"><span>Total</span><b>' + euro(cart.total_price) + '</b></div>';
    recap.hidden = false;
    recap.innerHTML = html;
  }

  function dessine(cart, options) {
    options = options || {};
    if (!racine || !cart) return;

    var manquants = [];
    cart.items.forEach(function (i) { if (!barresCache[i.handle] && manquants.indexOf(i.handle) === -1) manquants.push(i.handle); });

    function suite() {
      var gs = regroupe(cart);
      var sig = signature(gs, cart);
      if (!options.force && sig === empreinte) { panier = cart; groupes = gs; return; }
      var memes = groupes.length === gs.length && groupes.every(function (g, k) { return g.id === gs[k].id; }) && empreinte !== '';
      empreinte = sig;
      panier = cart;
      groupes = gs;

      compteur.textContent = cart.item_count;
      document.querySelectorAll('.cart-bubble__text-count, .cart-bubble__text, .theme-drawer__badge').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      if (dateEl) dateEl.textContent = dateArrivee();

      if (!cart.items.length) {
        racine.classList.add('is-vide');
        lignes.innerHTML = '<p class="nmc__vide">Votre panier est vide.<br><a href="' + RETOUR + '">Découvrir le sac</a></p>';
        recap.hidden = true;
        cta.classList.add('is-off');
        return;
      }
      racine.classList.remove('is-vide');
      cta.classList.remove('is-off');

      if (memes && !options.force) {
        gs.forEach(function (g) {
          var el = lignes.querySelector('.nmc__it[data-id="' + g.id + '"]');
          if (!el) return;
          var q = el.querySelector('[data-qte]');
          if (q && cibles[g.id] === undefined && q.textContent != g.qte) q.textContent = g.qte;
          var m = el.querySelector('[data-mult]');
          if (m) m.textContent = (g.cadeau && g.qte > 1) ? '×' + g.qte : '';
          var prix = g.cadeau ? 0 : g.total;
          var p = el.querySelector('[data-prix]');
          if (p) p.textContent = euro(prix);
          var b = el.querySelector('[data-barre]');
          if (b) b.textContent = g.base > prix ? euro(g.base) : '';
        });
      } else {
        var sacs = [], dons = [];
        gs.forEach(function (g) { (g.cadeau ? dons : sacs).push(ligneHTML(g)); });
        lignes.innerHTML = sacs.join('') + dons.join('');
      }
      majPied(cart, gs);
    }

    if (manquants.length) Promise.all(manquants.map(barres)).then(suite);
    else suite();
  }

  function veutQuantite(id, qte) {
    if (!panier) return;
    cibles[id] = qte;
    var ligne = lignes.querySelector('.nmc__it[data-id="' + id + '"]');
    if (ligne) {
      if (qte === 0) ligne.classList.add('is-going');
      else {
        ligne.classList.remove('is-going');
        var q = ligne.querySelector('[data-qte]');
        if (q) q.textContent = qte;
      }
    }
    if (minuteur) window.clearTimeout(minuteur);
    minuteur = window.setTimeout(envoie, DELAI);
  }

  function envoie() {
    if (envoiEnCours || !panier || !enFile()) return;
    var lot = cibles;
    cibles = {};
    envoiEnCours = true;
    version++;
    var maVersion = version;
    racine.classList.add('is-busy');

    var sacs = 0;
    groupes.forEach(function (g) {
      if (g.cadeau) return;
      sacs += (lot[g.id] !== undefined) ? lot[g.id] : g.qte;
    });

    /* Une variante peut occuper plusieurs lignes : la première reçoit le total, les autres zéro */
    var updates = {};
    groupes.forEach(function (g) {
      var cible = g.cadeau ? sacs : (lot[g.id] !== undefined ? lot[g.id] : null);
      if (cible === null) return;
      g.cles.forEach(function (k, idx) { updates[k] = idx === 0 ? cible : 0; });
    });

    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        if (maVersion !== version) return;
        panierA = Date.now();
        enAttente = null;
        dessine(cart);
      })
      .catch(function () {})
      .then(function () {
        envoiEnCours = false;
        racine.classList.remove('is-busy');
        if (enFile()) envoie();
      });
  }

  function charge(forcer) {
    if (!forcer && panier && Date.now() - panierA < 2000) return Promise.resolve(panier);
    var maVersion = version;
    return fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (cart) {
        if (maVersion !== version || envoiEnCours || enFile()) return panier;
        panierA = Date.now();
        if (anime) enAttente = cart; else dessine(cart);
        return cart;
      })
      .catch(function () { return panier; });
  }

  function ouvre() {
    if (!racine) return;
    if (fermeture) { window.clearTimeout(fermeture); fermeture = null; }
    if (!racine.hidden) { charge(); return; }
    racine.hidden = false;
    document.documentElement.classList.add('nmc-lock');
    anime = true;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { racine.classList.add('is-open'); });
    });
    window.setTimeout(function () {
      anime = false;
      if (enAttente) { dessine(enAttente); enAttente = null; }
    }, ANIM);
    charge();
  }

  function ferme() {
    if (!racine || racine.hidden) return;
    if (CONF.pagePanier) {
      var memeSite = document.referrer && document.referrer.indexOf(window.location.origin) === 0 &&
        document.referrer.indexOf('/cart') === -1;
      if (memeSite) window.history.back();
      else window.location.href = RETOUR;
      return;
    }
    if (minuteur) { window.clearTimeout(minuteur); minuteur = null; }
    if (enFile()) envoie();
    anime = true;
    racine.classList.remove('is-open');
    document.documentElement.classList.remove('nmc-lock');
    if (fermeture) window.clearTimeout(fermeture);
    fermeture = window.setTimeout(function () {
      racine.hidden = true;
      anime = false;
      if (enAttente) { dessine(enAttente); enAttente = null; }
    }, ANIM);
  }

  function branche() {
    racine = document.getElementById('nmc');
    if (!racine || racine.dataset.pret) return;
    racine.dataset.pret = '1';
    panneau = racine.querySelector('.nmc__panneau');
    lignes = racine.querySelector('[data-nmc-lignes]');
    compteur = racine.querySelector('[data-nmc-count]');
    cta = racine.querySelector('[data-nmc-checkout]');
    recap = racine.querySelector('[data-nmc-recap]');
    dateEl = racine.querySelector('[data-nmc-date]');

    racine.addEventListener('click', function (e) {
      if (e.target.closest('[data-nmc-close]')) { ferme(); return; }
      var it = e.target.closest('.nmc__it');
      if (!it) return;
      var id = it.dataset.id;
      var affiche = parseInt((it.querySelector('[data-qte]') || {}).textContent, 10);
      var q = (cibles[id] !== undefined) ? cibles[id] : (isNaN(affiche) ? 1 : affiche);
      if (e.target.closest('[data-plus]')) veutQuantite(id, q + 1);
      else if (e.target.closest('[data-moins]')) veutQuantite(id, Math.max(0, q - 1));
      else if (e.target.closest('[data-sup]')) veutQuantite(id, 0);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !racine.hidden) ferme();
    });

    var dernierClic = 0;
    document.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('a[href$="/cart"], a[href*="/cart?"], cart-icon, [data-testid="cart-icon"], .header-actions__cart-icon');
      if (!c || (c.closest && c.closest('#nmc'))) return;
      e.preventDefault();
      e.stopPropagation();
      var t = Date.now();
      if (t - dernierClic < 400) return;
      dernierClic = t;
      ouvre();
    }, true);

    var f = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && (arguments[0].url || arguments[0]);
      var p = f.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change)(\.js)?/.test(url)) {
        p.then(function () {
          panierA = 0;
          version++;
          window.setTimeout(function () { /\/cart\/add/.test(url) ? ouvre() : charge(true); }, 60);
        }).catch(function () {});
      }
      return p;
    };

    charge(true).then(function () {
      if (CONF.pagePanier) {
        document.documentElement.classList.add('nmc-page');
        ouvre();
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', branche);
  else branche();
})();
